// CustomRoute.js
import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import {
  Login,
  Home,
  Purpose,
  OnBoard,
  OnboardFinalStep,
  TransactionPage,
  Reupload,
  ForgotPassword,
  QrCodeStatic,
  OfflineOnboarding,
  OfflineTransaction,
  OfflineDocuments,
} from "./container";
import StatusScreen from "./component/Redirection/StatusScreen";
import { useMyContext } from "./myContext";

const CustomRoute = () => {
  const [loading, setLoading] = useState(true);
  const { isLoggedIn, setLoggedIn, isForgotRoute } = useMyContext("");

  const fetchAuthentication = async () => {
    try {
      const tokenString = sessionStorage.getItem("token");
      if (tokenString) {
        const token = JSON.parse(tokenString);
        const accessToken = token.accessToken;
        if (accessToken) {
          setLoggedIn(true);
        } else {
          setLoggedIn(false);
        }
      } else {
        setLoggedIn(false);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAuthentication();
  }, []);

  const handleLogin = () => {
    fetchAuthentication();
    setLoggedIn(true);
  };

  if (loading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "80px" }}
      >
        <Spinner animation="border" />
      </div>
    );
  }

  let newRoutes;
  if (isLoggedIn) {
    newRoutes = (
      <>
        <Route path="/purpose" element={<Purpose />} />
        <Route path="/onboard" element={<OnBoard />} />
        <Route path="/transaction-detail" element={<TransactionPage />} />
        <Route path="*" element={<Navigate to="/transaction-detail" />} />
        <Route path="/quote" element={<OnboardFinalStep />} />
        <Route path="/reuplod-document" element={<Reupload />} />
        <Route path="/payment" element={<QrCodeStatic />} />
        <Route path="/redirecting" element={<StatusScreen />} />
        <Route path="/offline-onboarding" element={<OfflineOnboarding />} />
        <Route path="/offline-transaction" element={<OfflineTransaction />} />
        <Route path="/offline-documents" element={<OfflineDocuments />} />
      </>
    );
  } else {
    newRoutes = (
      <>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route
          path="/forgot-password"
          element={
            isForgotRoute ? <ForgotPassword /> : <Navigate to="/login" />
          }
        />
        <Route path="*" element={<Navigate to="/login" />} />
        <Route path="/payment" element={<QrCodeStatic />} />
        <Route path="/redirecting" element={<StatusScreen />} />
      </>
    );
  }

  return <Routes>{newRoutes}</Routes>;
};

export default CustomRoute;
